import { render, staticRenderFns } from "./customerScaleDetail.vue?vue&type=template&id=147fc57a&scoped=true"
import script from "./customerScaleDetail.vue?vue&type=script&lang=js"
export * from "./customerScaleDetail.vue?vue&type=script&lang=js"
import style0 from "./customerScaleDetail.vue?vue&type=style&index=0&id=147fc57a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147fc57a",
  null
  
)

export default component.exports